export default (axios, baseURL) => {
    return{
        //
        index(){
            return axios.get(`${baseURL}/api/gerencies`)
        },
       
    }
}